module.exports = __webpack_public_path__ + "static/data-management-249ec776570033c3d235c8be2d797554.png";